import { useEffect, useRef } from "react";
import "./groupList.sass";

export default function GroupList({ groups, activeGroup, onSelect, groupsState = {} }) {
  const btnRefs = useRef({});

  const hasSimulatedTeams = (groupId) => {
    const group = groupsState[groupId];
    return group?.simulationState?.isSimulated ?? false;
  };

  useEffect(() => {
    const el = btnRefs.current[activeGroup];
    if (el) el.focus();
  }, [activeGroup]);

  const handleKeyDown = (e, current) => {
    const idx = groups.indexOf(current);
    if (idx === -1) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      const next = groups[Math.min(groups.length - 1, idx + 1)];
      onSelect(next, Math.min(groups.length - 1, idx + 1));
    }
    else if (e.key === "ArrowUp") {
      e.preventDefault();
      const prev = groups[Math.max(0, idx - 1)];
      onSelect(prev, Math.max(0, idx - 1));
    }
    else if (e.key === "Home") {
      e.preventDefault();
      onSelect(groups[0], 0);
    }
    else if (e.key === "End") {
      e.preventDefault();
      onSelect(groups[groups.length - 1], groups.length - 1);
    }
    else if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onSelect(current, idx);
    }
  };

  return (
    <div className="ContainerGroupList">
      <div className="GroupList" role="tablist" aria-orientation="vertical" aria-label="Grupos">
        {groups.map((gId) => {
          const isActive = gId === activeGroup && !hasSimulatedTeams(gId);
          const isSimulated = hasSimulatedTeams(gId);

          return (
            <button
              key={gId}
              ref={(el) => (btnRefs.current[gId] = el)}
              className={`GroupBtn ${isActive ? "is-active" : ""} ${isSimulated ? "is-simulate" : ""}`}
              role="tab"
              aria-selected={isActive}
              aria-controls={`panel-${gId}`}
              id={`tab-${gId}`}
              tabIndex={isActive ? 0 : -1}
              onClick={() => onSelect(gId, groups.indexOf(gId))}
              onKeyDown={(e) => handleKeyDown(e, gId)}
              type="button"
            >
              {gId}
            </button>
          );
        })}
      </div>
    </div>
  );
}